import cx from 'classnames';
import { isEmpty } from 'lodash';
import React, { FC } from 'react';

import useThemeBlock from '@/hooks/useThemeBlock';
import { ButtonProps } from '@/helpers/Button/typings';
import { Link } from '@/components/atoms/Link/render';

import block from './block.json';
import { getStyles } from './styles.css';

type ButtonSecondaryProps = {
	pageId?: string;
} & ButtonProps;

export const ButtonSecondary: FC<ButtonSecondaryProps> & BlockConfigs = ({
	title = '',
	href = '',
	opensInNewTab,
	className,
	theme = {},
	pageId = null,
	...props
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const rootClass = cx(
		className,
		'supt-button',
		'supt-buttonSecondary',
		getStyles(blockTheme)
	);

	return isEmpty(title) ? null : (
		<Link
			href={href}
			className={rootClass}
			{...(opensInNewTab && {
				target: '_blank',
				rel: 'noopener noreferrer',
			})}
			data-block={block.slug}
			data-variant={variant}
			{...props}
		>
			<span className="supt-button__inner">
				{title ? <span>{title}</span> : null}
			</span>
		</Link>
	);
};

ButtonSecondary.slug = block.slug;
ButtonSecondary.title = block.title;
